<div *ngFor="let alert of alerts" class="{{cssClass(alert)}} alert-dismissable cust-alert">
  <div>
    <p>{{alert.message}}</p>
    <a class="close ml-auto pointer r-30" (click)="removeAlert(alert)">&times;</a>
  </div>
</div>